// extracted by mini-css-extract-plugin
module.exports = {"root":"Profile_root__rHgE7","leftSide":"Profile_leftSide__GZJ1j","rightSide":"Profile_rightSide__5K85K","name":"Profile_name__qwOGy","email":"Profile_email__nC39j"};